import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { boxShadow, defaultContainerSize, mq } from '../../../styles/mixins';
import { Header2, ParagraphS } from '../../core/Typography/Typography';

export const Wrapper = styled.section`
  margin-top: 5rem;
`;

export const Inner = styled.div`
  display: flex;
  flex-direction: column;
  ${defaultContainerSize};
`;

export const InnerSecond = styled(Inner)`
  padding-bottom: 3.25rem;

  ${mq.xLarge(css`
    padding-bottom: 5.875rem;
  `)};
`;

export const Title = styled.h2`
  ${Header2};
  color: ${({ theme }) => theme.colors.black};
  margin: 0 0 2rem 0;

  ${mq.medium(css`
    font-size: 3rem;
    line-height: 3.5rem;
    margin-bottom: 2.5rem;
  `)};
`;

export const JobsIntroduction = styled.div`
  max-width: 35.4375rem;
`;

export const IntroductionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 2rem;

  ${mq.medium(css`
    margin-bottom: 5.625rem;
  `)};

  ${mq.large(css`
    flex-direction: row;
  `)};
`;

export const IntroductionTitle = styled.h2`
  color: ${({ theme }) => theme.colors.black};
  font-family: ${({ theme }) => theme.font.questrial};
  letter-spacing: -0.0125rem;
  font-weight: 400;
  font-size: 2rem;
  line-height: 2.5rem;
  max-width: 27rem;
  margin: 0 0 2rem 0;

  ${mq.medium(css`
    font-size: 3rem;
    line-height: 3.5rem;
    margin-bottom: 1rem;
  `)};
`;

export const PlayVideoContainer = styled.div`
  position: relative;
  padding: 2px;
  background-image: linear-gradient(
    100.54deg,
    #0e4ed7 0%,
    #7b4b93 48.44%,
    #f94743 100%
  );
  display: inline-block;
  border-radius: 5.75rem;
  margin-bottom: 2rem;
  width: 100%;

  ${mq.small(css`
    width: auto;
  `)};
`;

export const PlayVideoButton = styled.button`
  border: none;
  background-color: ${({ theme }) => theme.colors.core_white};
  font-family: ${({ theme }) => theme.font.questrial};
  color: ${({ theme }) => theme.colors.core_black};
  font-weight: 400;
  font-size: 1.25rem;
  line-height: 2rem;
  letter-spacing: 0.0125rem;
  border-radius: 5.75rem;
  padding: 0.75rem 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.625rem;
  width: 100%;

  ${mq.small(css`
    width: auto;
  `)};

  &:hover {
    background-color: ${({ theme }) => theme.colors.core_white};
  }
`;

export const PrimaryColor = styled.span`
  color: ${({ theme }) => theme.colors.primary};
`;

export const CarouselWrapper = styled.div`
  display: block;
  margin-bottom: 4rem;
  padding-right: 1rem;
  padding-left: 1rem;

  ${mq.medium(css`
    display: none;
  `)};
`;

export const TeamImageWrapper = styled.div`
  display: none;
  max-width: 85.25rem;
  max-height: 21.75rem;
  margin: 0 auto 3.5rem;
  padding-left: 1rem;
  padding-right: 1rem;

  ${mq.small(css`
    padding-left: 3.5rem;
    padding-right: 3.5rem;
  `)};

  ${mq.medium(css`
    display: block;
  `)};

  ${mq.xLarge(css`
    padding-left: 2rem;
    padding-right: 2rem;
    margin-bottom: 1.5rem;
  `)};

  img {
    width: 100%;
    height: 100%;
    max-width: 85.25rem;
    max-height: 21.75rem;
    border-radius: 0.5rem;
  }
`;

export const TeamImagesWrapper = styled.div`
  display: none;
  flex-direction: row;
  justify-content: center;
  gap: 1.28125rem;

  ${mq.xLarge(css`
    display: flex;
    margin-bottom: 3.5rem;
  `)};
`;

export const TeamImagesItem = styled.div`
  max-height: 12.8125rem;
  max-width: 15.375rem;

  img {
    height: 12.8125rem !important;
    max-height: 12.8125rem;
    max-width: 100%;
    object-fit: cover;
    border-radius: 0.5rem;
  }
`;

export const Jobs = styled.div``;

export const ContactWrapper = styled.div`
  position: relative;
  z-index: 2;
`;

export const ContactText = styled.p`
  font-size: 1.5rem;
  line-height: 2.25rem;
  color: ${({ theme }) => theme.colors.core_black};
  font-family: ${({ theme }) => theme.font.nunito};
  font-weight: 700;
  margin: 3rem 0 1.25rem;
  max-width: 22.4375rem;
`;

export const ActionButton = styled.a`
  box-sizing: border-box;
  width: 100%;
  color: ${({ theme }) => theme.colors.core_white};
  font-size: 1.25rem;
  line-height: 2rem;
  border: none;
  border-radius: 4rem;
  text-align: center;
  box-shadow: none;
  font-family: ${({ theme }) => theme.font.questrial};
  position: relative;
  padding: 0.75rem 3rem;
  background-color: ${({ theme }) => theme.colors.primary};
  transition: background-color 300ms ease-in-out;
  text-decoration: none;
  display: inline-block;
  ${boxShadow};

  ${mq.small(css`
    width: auto;
  `)};

  ${mq.xLarge(css`
    padding: 0.75rem 4rem;
    max-width: 17.875rem;
  `)};

  &:before {
    content: '';
    z-index: -1;
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    border-radius: 4rem;
    background: linear-gradient(67.33deg, #0e4ed7 -19.99%, #f94743 98.54%);
  }

  &:focus {
    outline: none;
  }

  &:hover {
    background-color: transparent;
  }
`;

export const JobDescription = styled.p`
  ${ParagraphS};
  color: ${({ theme }) => theme.colors.black};
  margin: 0 0 2.5rem 0;

  ${mq.medium(css`
    margin-bottom: 0;
  `)};
`;

export const JobBold = styled.strong`
  font-weight: 700;
`;

// ${mq.small(css`
//   width: auto;
// `)};
//
// ${mq.xLarge(css`
//   padding: 0.75rem 4rem;
//   max-width: 17.875rem;
// `)};
